export default __webpack_public_path__ + "static/media/profile.27ad037d.PNG";